<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import AppSidebar from './AppSidebar.vue';
import AppHeader from './AppHeader.vue';
import { useSidebar } from '@/composables/useSidebar';

const { collapsed } = useSidebar();
const mobileOpen = ref(false);

const bodyMargin = computed(() => (collapsed.value ? '72px' : '260px'));

watch(mobileOpen, (open) => {
  document.body.style.overflow = open ? 'hidden' : '';
});
</script>

<template>
  <!-- Mobile overlay -->
  <Transition name="overlay-fade">
    <div v-if="mobileOpen" class="mob-overlay" @click="mobileOpen = false" />
  </Transition>

  <div class="app-shell">
    <AppSidebar
      :class="{ 'sidebar--mobile-open': mobileOpen }"
      @close="mobileOpen = false"
    />

    <div class="app-shell__body" :style="{ marginLeft: bodyMargin }">
      <AppHeader @menu-click="mobileOpen = !mobileOpen" />
      <main class="app-shell__main">
        <slot />
      </main>
    </div>
  </div>
</template>

<style scoped>
.app-shell {
  display: flex;
  min-height: 100dvh;
  background: #fcfcfd;
  overflow-x: clip;
}

.app-shell__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 0;
  overflow-x: clip;
  /* overflow: hidden brise position:sticky du header — on utilise clip sur x uniquement */
}

.app-shell__main {
  flex: 1;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  overflow-x: clip;
  overflow-y: visible;
}
/* Les pages gèrent leur propre padding via leur contenu */

/* Mobile: sidebar off-screen, body fills 100% */
@media (max-width: 767px) {
  .app-shell__body {
    margin-left: 0 !important;
  }
}

/* Mobile overlay */
.mob-overlay {
  position: fixed;
  inset: 0;
  z-index: 49;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
}
.overlay-fade-enter-active,
.overlay-fade-leave-active {
  transition: opacity 0.25s ease;
}
.overlay-fade-enter-from,
.overlay-fade-leave-to {
  opacity: 0;
}
</style>

<style>
[data-theme='dark'] .app-shell {
  background: #0c1421;
}
</style>
